import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router-dom';
import NavbarLink from '../../links/NavbarLink';

const LoggedOutNavItems = ({ title, to }) => {
  const location = useLocation();
  const isDemo = location.pathname.includes('quick-registration');

  return (
    <Grid container alignItems="center" justifyContent="flex-end" spacing={2}>
      <Grid item>
        <NavbarLink
          id="nav-login"
          to={to}
          title={isDemo ? '' : title}
        />
      </Grid>
    </Grid>
  );
};

LoggedOutNavItems.propTypes = {
  title: PropTypes.string.isRequired,
  to: PropTypes.string,
};

LoggedOutNavItems.defaultProps = { to: '/user-login' };

export default LoggedOutNavItems;
